<template>
  <div class="product">
    <div class="row my-3">
      <div class="col-12">
        <h2 class="">{{ $t('restAddProduct.createProduct') }}</h2>
      </div>
    </div>
    <div class="row">
      <div class="col-12 mb-4">
        <button @click="returnBack" class="btn btn-sm btn-outline-success">{{ $t('restAddProduct.goBack') }}
        </button>
      </div>
      <div class="col-12 col-xxl-7">
        <div v-show="Object.values(this.categories).length === 0" class="alert alert-warning alert-dismissible fade show" role="alert">
          <strong>{{ $t('restAddProduct.noCategoriesPleaseCreate') }}<br>
            <router-link :to="{name: 'RestCategories'}">{{ $t('restAddProduct.createCategory') }}</router-link>
          </strong>
          <button type="button" class="btn-close" data-bs-dismiss="alert" aria-label="Close"></button>
        </div>
        <div class="row">
          <div class="col-6 col-md-3 mb-3">
            <img src="@/assets/img/placeholder.jpg" class="img-fluid" :alt="$t('restAddProduct.burger')">
          </div>
          <div class="col-12 col-md-9 mb-3">
            <label for="formFile" class="form-label">{{ $t('restAddProduct.image') }}</label>
            <input v-on:change="this.inputFileImageChange()" class="form-control" type="file" id="formFile" aria-describedby="fileHelp" multiple>
            <div id="fileHelp" class="form-text">{{ $t('restAddProduct.imageRequirements') }}<br>{{ $t('restAddProduct.imageRequirementsResolution') }}</div>
          </div>
        </div>
        <div class="row">
          <div class="mb-3 col-6 col-md-5">
            <label for="prodTitle" class="form-label">{{ $t('restAddProduct.title') }}</label>
            <input v-model.trim="this.product.title" type="text" class="form-control" id="prodTitle">
          </div>
          <div class="mb-3 col-6 col-md-3">
            <label for="prodCategory" class="form-label">{{ $t('restAddProduct.category') }}</label>
            <select v-model="this.product.category" class="form-select" aria-label="Select category"
                    id="prodCategory">
              <option disabled value="">{{ $t('restAddProduct.select') }}</option>
              <option v-for="(value, key) in this.categories"
                      :key="key"
                      :value="value">
                {{ value }}
              </option>
            </select>
          </div>
          <div class="mb-3 col-6 col-md-2">
            <label for="prodPrice" class="form-label">{{ $t('restAddProduct.pricePlusCurrency') }}</label>
            <input v-model.number.trim="this.product.price" type="number" class="form-control"
                   id="prodPrice" step="1" min="1">
          </div>
          <div class="mb-3 col-6 col-md-2">
            <div class="d-flex justify-content-between align-items-center">
              <label for="prodWeight" class="form-label">{{ $t('restAddProduct.weightPlusUnit') }}</label>
              <div class="col-auto">
                <select v-model="this.product.unit_measure" class="form-select form-select-sm select-measure py-0" aria-label="Select product measure" id="prodMeasure">
                  <option v-for="(value, key) in this.PRODUCT_MEASURE"
                          :key="key" :value="value">
                    {{ value }}
                  </option>
                </select>
              </div>
            </div>
            <input v-model.number.trim="this.product.weight" type="number" class="form-control"
                   id="prodWeight">
          </div>
          <div class="mb-3 col-12">
            <label for="prodDesacription" class="form-label">{{ $t('restAddProduct.description') }}</label>
            <textarea v-model.trim="this.product.description" class="form-control"
                      id="prodDesacription" rows="3"></textarea>
          </div>
        </div>
        <div class="d-flex justify-content-between  align-items-center">
          <div class="d-flex gap-4">
            <div class="form-check form-switch">
              <input
                  v-model="this.product.is_available"
                  class="form-check-input"
                  type="checkbox" role="switch" id="prodIsAvailable" checked>
              <label class="form-check-label" for="prodIsAvailable">{{ $t('restAddProduct.active') }}</label>
            </div>

          </div>
          <div>

            <button
                v-on:click="clearInputs"
                type="reset" class="btn btn-outline-secondary">{{ $t('restAddProduct.clear') }}
            </button>
            <button v-if="this.loading" class="btn btn-btn-success ms-3" type="button" disabled>
              <span class="spinner-border spinner-border-sm" role="status" aria-hidden="true"></span>
              {{ $t('restAddProduct.loading') }}
            </button>
            <button v-else
                    v-on:click="addProduct"
                    :disabled="!this.disabledBtnSend"
                    type="submit" class="btn btn-success ms-3"> {{ $t('restAddProduct.save') }}
            </button>
          </div>
        </div>
      </div>
    </div>


  </div>
</template>

<script>

import {mapGetters} from "vuex";
import i18n from "@/i18n";
import axios from "axios";
import router from "@/router";
const config = require('@/config')

export default {
  name: "RestAddProduct",
  data() {
    return {
      categories: {},
      productImage: '',
      product: {
        title: '',
        category: '',
        description: '',
        price: 0,
        weight: 0,
        is_available: true,
        unit_measure: ''
      },
      alert: {
        show: true,
        style: 'alert-success',
        msg: 'Test',
        loading: false
      },
      loading: false,
    }
  },
  computed: {
    ...mapGetters([
      'RESTAURANT',
      'PRODUCT_MEASURE',
    ]),
    disabledBtnSend() {
      if (
          this.product.title &&
          this.product.category &&
          this.product.description &&
          this.product.price > 0 &&
          this.productImage !== ''
      ) {
        return true
      } else {
        return false
      }
    },
  },
  methods: {
    inputFileImageChange() {
      let img = document.querySelector('#formFile').value
      this.productImage = img
    },
    async addImage(id) {
      await this.$store.dispatch('checkIdToken')
      let idToken = this.$store.state.tokens.idToken;
      let restId = this.$route.params.id
      let fileImage = document.querySelector('#formFile').files[0];
      let axiosHeader = {headers: {"Authorization": idToken, "Content-Type": 'multipart/form-data'}}
      const formData = new FormData();
      formData.append('fileContent', fileImage);
      formData.append('entityType', 'menu_item');
      formData.append('restaurantId', restId);
      formData.append('menuItemId', id);
      axios.post(`${config.servUrl}admin/image-upload`, formData, axiosHeader)
          .then(response => {
            this.$store.dispatch('addNewNotice', {text: i18n.global.t('restAddProduct.productAdded')})
            this.loading = false;
            this.clearInputs();
            this.$store.dispatch('getRestaurantMenu', restId);
            router.go(-1)
          })
          .catch(error => {
            console.log(error);
            this.$store.dispatch('addNewNotice', {text: error, error: true})
            this.loading = false;
          })
    },
    async addProduct() {
      await this.$store.dispatch('checkIdToken')
      let idToken = this.$store.state.tokens.idToken;
      let restId = this.$route.params.id
      let axiosHeader = {headers: {"Authorization": idToken, "Content-Type": 'application/json'}}
      let data = JSON.stringify(this.product)
      this.loading = true
      axios.post(`${config.servUrl}admin/menu-items/${restId}`, data, axiosHeader)
          .then(response => {
            this.addImage(response.data.id);
          })
          .catch(error => {
            console.log(error);
            this.$store.dispatch('addNewNotice', {text: error, error: true})
            this.loading = false;
          })
    },
    clearInputs() {
      this.product.title = ''
      this.product.category = ''
      this.product.description = ''
      this.product.price = ''
      this.product.weight = ''
      document.querySelector('#formFile').value = ''
    },
    returnBack() {
      router.go(-1)
    }
  },
  watch: {
    'product': {
      handler() {

      },
      deep: true
    },
    productImage() {
      this.disabledBtnSend
    }
  },
  mounted() {
    if (this.RESTAURANT.settings) {
      this.categories = this.RESTAURANT.settings['category_sequence']
    }
    this.alert.show = false
    this.alert.style = 'alert-success'
    this.product.unit_measure = this.PRODUCT_MEASURE[0]
  }
}
</script>

<style scoped>

</style>
